import * as DS from "@equipmentshare/es-design-tokens-css-values";
import { transparentize } from "polished";

export type Color = string;

export const translucentBlack = (opacity = 0.1): Color =>
  transparentize(1 - opacity)(black());

export const translucentColor = (color: Color, opacity = 0.1): Color =>
  transparentize(1 - opacity)(color);

export const clear = (): Color => translucentBlack(0);
export const black = (): Color => DS.COLORS.$color_gray_900;
export const gray = (): Color => DS.COLORS.$color_gray_700;
export const steel = (): Color => DS.COLORS.$color_gray_500;
export const mist = (): Color => DS.COLORS.$color_gray_300;
export const denseFog = (): Color => DS.COLORS.$color_gray_200;
export const veryWhiteGrey = (): Color => DS.COLORS.$color_gray_100;
export const almostWhite = (): Color => DS.COLORS.$color_gray_50;
export const white = (): Color => DS.COLORS.$color_primary_white;

export const azure = (): Color => DS.COLORS.$color_primary_blue;
export const mustard = (): Color => DS.COLORS.$color_primary_yellow;
export const green = (): Color => DS.COLORS.$color_primary_green;
export const guardsmanRed = (): Color => DS.COLORS.$color_primary_red;
